module.exports = __webpack_public_path__ + "static/media/TN-Women-Wallets.beec4a46.svg";